import HCRender from "../hc-render"

const ContentPage = ({
  rootCategoriesData,
  onArticleSelect,
  onCategorySelect,
  expandedCategories,
  currentPath,
  isLoading,
  error,
  selectedContent,
  contentType,
  onFeedback,
  navigateTo,
}) => {
  const Sidebar = HCRender.getFragment("Sidebar")
  const MainContent = HCRender.getFragment("MainContent")
  const RequestLink = HCRender.getFragment("RequestLink")

  return (
    <div className="relative flex flex-col lg:flex-row w-full pb-[240px]">
      {Sidebar && (
        <Sidebar
          rootCategoriesData={rootCategoriesData}
          onArticleSelect={onArticleSelect}
          onCategorySelect={onCategorySelect}
          expandedCategories={expandedCategories}
          currentPath={currentPath}
        />
      )}

      {MainContent && (
        <MainContent
          isLoading={isLoading}
          error={error}
          selectedContent={selectedContent}
          contentType={contentType}
          onFeedback={onFeedback}
          navigateTo={navigateTo}
        />
      )}

      <div className="absolute bottom-[60px] md:bottom-[112px] left-1/2 translate-x-[-50%] w-full">
        {RequestLink && <RequestLink />}
      </div>
    </div>
  )
}

export default ContentPage
